import React, { useEffect } from 'react';
import { PianoAdvertorial } from './pages/PianoAdvertorial';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
    clarity: any;
  }
}
export function App() {
  useEffect(() => {
    // Store fbclid from URL
    const fbclid = new URLSearchParams(window.location.search).get('fbclid');
    if (fbclid) sessionStorage.setItem('fbclid', fbclid);

    // Facebook Pixel
    if (!window.fbq) {
      const fbq: any = function () {
        fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = fbq;
      window.fbq = fbq;
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
    }
    window.fbq('init', '25771694632496569');
    window.fbq('track', 'PageView');
    const fbScript = document.createElement('script');
    fbScript.async = true;
    fbScript.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(fbScript);

    // Clarity setup
    if (!window.clarity) {
      window.clarity = function () {
        ;
        (window.clarity.q = window.clarity.q || []).push(arguments);
      };
    }
    const clarityScript = document.createElement('script');
    clarityScript.async = true;
    clarityScript.src = 'https://www.clarity.ms/tag/vcs5a8w3b5';
    document.head.appendChild(clarityScript);
  }, []);
  return <div className="w-full min-h-screen bg-gray-50 pb-28 md:pb-28" data-id="element-0">
      <PianoAdvertorial data-id="element-1" />
    </div>;
}